"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var _default = exports.default = {
  getActList: function getActList(params) {
    return (0, _requestPIM.default)({
      url: '/xyTietuActivity/page',
      method: 'get',
      params: params
    });
  },
  addAct: function addAct(data) {
    return (0, _requestPIM.default)({
      url: '/xyTietuActivity/saveOrUpdate',
      method: 'post',
      data: data
    });
  },
  getDetail: function getDetail(id) {
    return (0, _requestPIM.default)({
      url: '/xyTietuActivity/' + id,
      method: 'get'
    });
  },
  changeActStatus: function changeActStatus(data) {
    return (0, _requestPIM.default)({
      url: '/xyTietuActivity/updateStatus',
      method: 'post',
      data: data
    });
  },
  getRecordList: function getRecordList(params) {
    return (0, _requestPIM.default)({
      url: '/xyTietuRecord/page',
      method: 'get',
      params: params
    });
  },
  exportRecordData: function exportRecordData(params) {
    return (0, _requestPIM.default)({
      url: '/xyTietuRecord/exportList',
      method: 'get',
      params: params,
      responseType: 'blob'
    });
  },
  // 根据第三方券id查询券信息
  getCouponByThirdId: function getCouponByThirdId(id) {
    return (0, _requestPIM.default)({
      url: '/xyCouponExpand/getCouponByThirdId?id=' + id,
      method: 'get'
    });
  }
};